export default {

  methods: {

    set_LocalValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems))

      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.config     = json.config
      this.menus      = json.menus
      this.title      = json.title
      this.schedule   = json.schedule
      this.chart      = json.chart
      this.header     = json.header
      this.table      = json.table
      this.columns    = json.columns
      this.sundries   = json.sundries

      // Columns
      this.gmx_tableCoordinates('x', this.columns, this.table.padding)
      this.header.width = this.columns[this.columns.length-1].ex

      // Header
      this.header.depths = []
      let y_ = 0
      this.header.depth.forEach((d,i)=> {
        y_ = y_ + d
        this.header.depths[i] = y_
      })
      this.header.height = y_
    
      this.current = {menu: this.config.default}
    },


    init_dataSetValues() {
      
      this.dataSet = null

      this.dataSet = this.rawData.filter(f=> f[this.config.refCode] == this.current.menu)
      this.table.height = this.header.height + (this.dataSet.length*this.table.lineHeight)
    }


  }
}